import React, { useRef, useState, useEffect } from "react";
import EmployeeLayout from "../../../layout/EmployeeLayout";
import strings from "../../../translation";
import Control from "./Control"; // adjust path based on your folder structure
import { useSelector, useDispatch } from "react-redux";
import ReactPlayer from "react-player";
import SignatureCanvas from "react-signature-canvas";
import "./signatureStyle.css";
import { useLocation, useHistory } from "react-router-dom";

export const formatTime = (time) => {
  if (isNaN(time)) return "00:00";
  const date = new Date(time * 1000);
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds().toString().padStart(2, "0");
  return hours
    ? `${hours}:${minutes.toString().padStart(2, "0")}`
    : `${minutes}:${seconds}`;
};

let count = 0;

const TrainingVideo = () => {
  const videoRef = useRef(null);
  const signatureRef = useRef(null);
  const controlRef = useRef(null);
  const history = useHistory();

  const [paused, setPaused] = useState(false);
  const [isVideoCompleted, setIsVideoCompleted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [signatureURL, setSignatureURL] = useState(null);
  const [loading, setLoading] = useState(false);
  const [lastPlayed, setLastPlayed] = useState(0);
  const [videoState, setVideoState] = useState({
    playing: false,
    muted: true,
    volume: 0.0,
    playbackRate: 1.0,
    played: 0,
    seeking: false,
    buffer: true,
  });

  const currentTime = videoRef.current ? videoRef.current.getCurrentTime() : 0;
  const duration = videoRef.current ? videoRef.current.getDuration() : 0;
  const formatCurrentTime = formatTime(currentTime);
  const formatDuration = formatTime(duration);

  const user = useSelector((state) => state.login.loginInfo);
  const location = useLocation();
  const { jobSite } = location.state || {};
  const video = useSelector((state) => state.employeeHome.video);
  const signatureStatus = useSelector(
    (state) => state.employeeHome.signatureStatus
  );
  const signatureRequesting = useSelector(
    (state) => state.employeeHome.signatureRequesting
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: "GET_VIDEO" });
  }, []);

  useEffect(() => {
    if (video?.length > 0) {
      dispatch({
        type: "SIGNATURE_STATUS",
        id: video[0]?.id,
        meeting_id: video[0]?.meetings[0],
      });
    }
  }, [video, signatureRequesting]);

  useEffect(() => {
    setLoading(false);
    if (signatureStatus) {
      history.push({
        pathname: "/employee/quiz",
        state: {
          id: video[0]?.id,
          meeting_id: video[0]?.meetings[0],
        },
      });
    }
  }, [signatureStatus]);

  useEffect(() => {
  const timer = setTimeout(() => {
    setVideoState((prev) => ({
      ...prev,
      muted: false,
      playing: true, // Start playing the video after unmute
      volume: 0.5, // Set initial audible volume after unmute
    }));
  }, 2000); // Delay for autoplay compatibility

  return () => clearTimeout(timer);
}, []);

  const {
    playing,
    muted,
    volume,
    playbackRate,
    played,
    seeking,
    buffer,
  } = videoState;

  const handleEnded = () => {
    setIsVideoCompleted(true);
    setShowModal(true);
  };

  const handleClear = () => signatureRef.current.clear();

  const handleSubmitSignature = () => {
    if (signatureRef.current.isEmpty()) {
      alert(strings.PLEASE_ADD_YOUR_SIGNATURE_FIRST);
      return;
    }

    const dataURL = signatureRef.current.toDataURL();
    setLoading(true);

    const data = {
      video_id: video[0]?.id,
      jobsite_id: jobSite?.id,
      company_id: user?.users?.employee_company_detail[0].company,
      meeting_id: video[0]?.meetings[0],
      signature: dataURL,
    };

    dispatch({
      type: "SIGNATURE",
      data: data,
      id: video[0]?.id,
      meeting_id: video[0]?.meetings[0],
    });
  };

  const handleProgress = (state) => {
    if (state.playedSeconds - lastPlayed > 2) {
      videoRef.current.seekTo(lastPlayed);
    } else {
      setLastPlayed(state.playedSeconds);
    }
  };

  const playPauseHandler = () =>
    setVideoState({ ...videoState, playing: !playing });

  const rewindHandler = () =>
    videoRef.current.seekTo(videoRef.current.getCurrentTime() - 5);

  const handleFastFoward = () =>
    videoRef.current.seekTo(videoRef.current.getCurrentTime() + 10);

  const progressHandler = (state) => {
    if (count > 3) {
      controlRef.current.style.visibility = "hidden";
    } else if (controlRef.current.style.visibility === "visible") {
      count += 1;
    }

    if (!seeking) {
      setVideoState({ ...videoState, ...state });
    }
  };

  const seekHandler = (e, value) => {
    setVideoState({ ...videoState, played: value / 100 });
    videoRef.current.seekTo(value / 100);
  };

  const seekMouseUpHandler = (e, value) => {
    setVideoState({ ...videoState, seeking: false });
    videoRef.current.seekTo(value / 100);
  };

  const volumeChangeHandler = (e, value) => {
    const newVolume = value / 100;
    setVideoState({
      ...videoState,
      volume: newVolume,
      muted: newVolume === 0,
    });
  };

  const volumeSeekUpHandler = (e, value) => {
    const newVolume = value / 100;
    setVideoState({
      ...videoState,
      volume: newVolume,
      muted: newVolume === 0,
    });
  };

  const muteHandler = () =>
    setVideoState({ ...videoState, muted: !videoState.muted });

  const onSeekMouseDownHandler = () =>
    setVideoState({ ...videoState, seeking: true });

  return (
    <EmployeeLayout isActive={strings.HOME}>
      <div className="company-home-section">
        {video?.length > 0 ? (
          <div className="video-container">
            <ReactPlayer
              ref={videoRef}
              url={video[0]?.video}
              playing={playing}
              muted={muted}
              volume={volume}
              width="100%"
              onProgress={handleProgress}
              onEnded={handleEnded}
            />
            <div
              style={{
                position: "relative",
                width: "100%",
                background: "#B73F36",
                height: 60,
                textAlign: "center",
              }}
            >
              <Control
                controlRef={controlRef}
                onPlayPause={playPauseHandler}
                playing={playing}
                onRewind={rewindHandler}
                onForward={handleFastFoward}
                played={played}
                onSeek={seekHandler}
                onSeekMouseUp={seekMouseUpHandler}
                volume={volume}
                onVolumeChangeHandler={volumeChangeHandler}
                onVolumeSeekUp={volumeSeekUpHandler}
                mute={muted}
                onMute={muteHandler}
                playRate={playbackRate}
                duration={formatDuration}
                currentTime={formatCurrentTime}
                onMouseSeekDown={onSeekMouseDownHandler}
              />
            </div>
          </div>
        ) : (
          <div className="no-jobsite-message">
            {strings.NO_VIDEO_FOR_TODAY}
          </div>
        )}

        {showModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h5>{strings.ADD_SIGNATURE}</h5>
              <SignatureCanvas
                ref={signatureRef}
                canvasProps={{
                  width: 500,
                  height: 200,
                  className: "signatureCanvas",
                }}
              />
              <div className="button-row">
                <button
                  style={{
                    backgroundColor: loading ? "#FCD329" : "#FED200",
                  }}
                  className="modal-submit"
                  onClick={handleSubmitSignature}
                  disabled={loading}
                >
                  {strings.SUBMIT}
                </button>
                <button className="modal-clear" onClick={handleClear}>
                  {strings.CLEAR}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </EmployeeLayout>
  );
};

export default TrainingVideo;
